<template>
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.74074 7.2963L4.7037 10.2593" stroke="#44B358" stroke-width="2" stroke-linecap="round"/>
        <path d="M5.07411 10.2857L12.4815 1.71429" stroke="#44B358" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'article-icon'
}
</script>